import React from 'react';
import { Flex, Text, Card, Img, View } from '@smarterservices/smarter-ui';
import {
  getStore,
} from '../../../stores/StoreContext';
import CONSTANTS from '../../../config/constants';

const Identity = () => {
  const ExamSessionStore = getStore('examSessionStore');

  return (
    <Flex>
      <Flex.Item
        as="div"
        width="50%"
        align="start"
        padding="none small none none"
      >
        <Card>
          <Card.Header
            background="brand"
            padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
          >
            <Card.Title>
              <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>
                Headshot
              </Text>
            </Card.Title>
          </Card.Header>
          <Card.Body padding={CONSTANTS.STYLES.CARD_BODY_PADDING} minHeight="200px">
            <View as="div" textAlign="center">
              {ExamSessionStore.sessionData?.photos?.headshot?.original?.[0]?.url ? (
                <Img src={ExamSessionStore.sessionData.photos.headshot.original[0].url} />
              ) : (
                <View as="div" margin="large 0 0 0">
                  <Text variant={CONSTANTS.STYLES.CARD_BODY_TEXT_VARIANT}>
                    No Image Found
                  </Text>
                </View>
              )}
            </View>
          </Card.Body>
        </Card>
      </Flex.Item>
      <Flex.Item as="div" shouldGrow width="50%" align="start">
        <Card>
          <Card.Header
            background="brand"
            padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
          >
            <Card.Title>
              <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>
                Identification
              </Text>
            </Card.Title>
          </Card.Header>
          <Card.Body padding={CONSTANTS.STYLES.CARD_BODY_PADDING} minHeight="200px">
            <View as="div" textAlign="center">
              {ExamSessionStore.sessionData?.photos?.idFront?.original?.[0]?.url ? (
                <Img src={ExamSessionStore.sessionData.photos.idFront.original[0].url} />
              ) : (
                <View as="div" margin="large 0 0 0">
                  <Text variant={CONSTANTS.STYLES.CARD_BODY_TEXT_VARIANT}>
                    No Image Found
                  </Text>
                </View>
              )}
            </View>
          </Card.Body>
        </Card>
      </Flex.Item>
    </Flex>
  );
};

export default Identity;
